module.exports = __webpack_public_path__ + "img/ic_daily_attendance.f08d8ca4.png";